import type { ReactElement } from 'react';
import type { SkuTag as TSkuTag } from 'models/ISku';
import { TagName } from 'models/ISku';

import { Component as LowCalories } from 'icons/icon-ui--less-than-600-calories.svg';
import { Component as BoneHealth } from 'icons/icon-ui--bone-health.svg';
import { Component as ChefsChoice } from 'icons/icon-ui--chef-s-choice.svg';
import { Component as GlutenFree } from 'icons/icon-circle-lime--gluten-free.svg';
import { Component as HealthyCarbs } from 'icons/icon-ui--healthy-carbs.svg';
import { Component as HeartHealth } from 'icons/icon-ui--heart-health.svg';
import { Component as HighFiber } from 'icons/icon-ui--high-fiber.svg';
import { Component as HighProtein } from 'icons/icon-ui--high-protein.svg';
import { Component as LessPrep } from 'icons/icon-circle-lime--clock.svg';
import { Component as LowNa } from 'icons/icon-ui--low-sodium.svg';
import { Component as NutFree } from 'icons/icon-ui--nut-free.svg';
import { Component as SoyFree } from 'icons/icon-ui--soy-free.svg';
import { Component as Spicy } from 'icons/icon-ui--spicy.svg';

const iconsMap = {
  [TagName.LOW_CALORIES]: LowCalories,
  [TagName.BONE_HEALTH]: BoneHealth,
  [TagName.CHEFS_CHOICE]: ChefsChoice,
  [TagName.GLUTEN_FREE]: GlutenFree,
  [TagName.HEALTHY_CARBS]: HealthyCarbs,
  [TagName.HEART_HEALTH]: HeartHealth,
  [TagName.HIGH_FIBER]: HighFiber,
  [TagName.HIGH_PROTEIN]: HighProtein,
  [TagName.LESS_PREP]: LessPrep,
  [TagName.LOW_SODIUM]: LowNa,
  [TagName.NUT_FREE]: NutFree,
  [TagName.SOY_FREE]: SoyFree,
  [TagName.SPICY]: Spicy,
};

type Props = {
  tags: TSkuTag[];
};

function SkuTag({ tagName }: { tagName: TagName | string }): ReactElement {
  const Icon = iconsMap[tagName];

  // @ts-expect-error TODO: fix null safety
  return Icon ? (
    <span title={tagName}>
      <Icon className="c-recipe__tag" width="24" height="24" />
    </span>
  ) : null;
}

function SkuTags({ tags }: Props): ReactElement {
  return (
    <div className="c-recipe__tags">
      {tags.map((tag, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SkuTag key={`${tag.id}_${index}`} tagName={tag.name} />
      ))}
    </div>
  );
}

export default SkuTags;
